import Content from "@/components/Content.tsx";
import MyTipsPage from "@/friendlyWagers/MyTipsPage.tsx";
import Header from "@/Header.tsx";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";

/** Friendly Wagers: the player's balances, games to back, open and settled tips. */
export const Route = createFileRoute('/_app/friendly-wagers/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header />
        <Content>
            <MyTipsPage />
        </Content>
    </>
}
